import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import styles from './NoResults.module.less';

export interface NoResultsProps {
  handleClearFilters: () => void;
}
export const NoResults = ({ handleClearFilters }: NoResultsProps): JSX.Element => {
  return (
    <div className={styles.simpleNoResultsContainer} data-testid="no-search-results">
      <h2>No results found.</h2>
      <h3> Try adjusting your search or clearing any filters you&apos;ve applied.</h3>
      <LinkV2 role="button" onClick={handleClearFilters} noTextTransform>
        Clear filters
      </LinkV2>
    </div>
  );
};
